import { useState, ReactElement, useEffect } from 'react';
import { ErrorIcons } from './_ErrorIcons';

interface EventProps {
  src: string | undefined;
  alt?: string;
  className?: string;
}

const ImageOnError = ( { src, alt = '', className = '' } : EventProps ) => {

  const [ image, setImage ] = useState<ReactElement | undefined >(
    <img
      src={src}
      alt={alt}
      className={className}
      onError={ () => {
        setImage( <ErrorIcons error={'no_image'} className={className}/> );
      }}
    />
  );

  useEffect( () => {
    setImage(
      <img
        src={src}
        alt={alt}
        className={className}
        onError={ () => {
          setImage( <ErrorIcons error={'no_image'} className={className}/> );
        }}
      />
    ) ;
  }, [ src, className, alt ] );

  return image;
};

export default ImageOnError;